<ng-container [formGroup]="group">
  <div class="hf-input-group">
    <span
      class="hf-form-control-icon"
      (click)="clear()"
    >
      <i *ngIf="!hasValue" class="material-icons">{{ icon }}</i>
      <i *ngIf="hasValue" class="material-icons">close</i>
    </span>
    <input
      #input
      class="form-control hf-form-control"
      [name]="fieldName"
      [id]="fieldName"
      type="text"
      formControlName="searchBox"
      [placeholder]="placeholder"
      tabindex="0"
    />
  </div>
</ng-container>
